"use client";

import { FaEnvelopeOpenText, FaPenToSquare } from "react-icons/fa6";
import { useTranslations } from "next-intl";
import { Button } from "@/components/ui/Button";
const SuccessState = ({
  onClick,
  emailSentTo
}: {
  onClick: React.MouseEventHandler;
  emailSentTo: string;
}) => {
  const t = useTranslations("signup_form");
  return <div className="mb-3 max-w-xs text-center text-sm" data-sentry-component="SuccessState" data-sentry-source-file="SuccessState.tsx">
      <FaEnvelopeOpenText className="mb-3 inline-block text-4xl text-primary" data-sentry-element="FaEnvelopeOpenText" data-sentry-source-file="SuccessState.tsx" />
      <p>{t("email_sent_to")}</p>
      <Button endContent={<FaPenToSquare />} className="my-1 px-2 py-1 text-primary" size="sm" onClick={onClick} data-sentry-element="Button" data-sentry-source-file="SuccessState.tsx">
        <span>{emailSentTo}</span>
      </Button>
      <p>{t("email_sent_link_info")}</p>
      <p>{t("email_sent_check_spam")}</p>
    </div>;
};
export { SuccessState };